import React from 'react';
import { Type } from 'lucide-react';

const TitleEditor = ({ title = '', subtitle = '', calculateButtonText = '', onChange }) => {
  return (
    <div className="admin-section" data-testid="title-editor-section">
      <h3 className="admin-section-title flex items-center gap-2">
        <Type size={18} className="text-yellow-400" /> Başlıq
      </h3>
      <p className="admin-section-desc">
        Səhifənin yuxarısında göstərilən başlıq, alt başlıq və hesablama düyməsinin adını redaktə edin.
      </p>

      <div className="title-editor-grid">
        <div>
          <label className="title-editor-label">Əsas başlıq</label>
          <input
            type="text"
            className="karma-input text-left w-full"
            value={title}
            onChange={(e) => onChange({ title: e.target.value })}
            maxLength={100}
            placeholder="Karma Matrisi Kalkulyatoru"
            data-testid="title-input"
          />
          <span className="title-editor-hint">{title.length}/100</span>
        </div>

        <div>
          <label className="title-editor-label">Alt başlıq</label>
          <textarea
            className="karma-input text-left w-full"
            value={subtitle}
            onChange={(e) => onChange({ subtitle: e.target.value })}
            maxLength={300}
            rows={3}
            placeholder="by Karma Akademi Canada"
            data-testid="subtitle-input"
            style={{ resize: 'vertical', minHeight: 64, fontFamily: 'inherit' }}
          />
          <span className="title-editor-hint">{subtitle.length}/300 — yeni sətir üçün Enter</span>
        </div>

        <div>
          <label className="title-editor-label">Hesablama düyməsinin adı</label>
          <input
            type="text"
            className="karma-input text-left w-full"
            value={calculateButtonText}
            onChange={(e) => onChange({ calculate_button_text: e.target.value })}
            maxLength={50}
            placeholder="Calculate Matrix (boş buraxılsa dilə görə avtomatik)"
            data-testid="calculate-button-text-input"
          />
          <span className="title-editor-hint">{calculateButtonText.length}/50 — boş qoyulsa hər dil üçün default tərcümə işlədilir</span>
        </div>
      </div>

      {/* Live preview */}
      <div className="title-preview" data-testid="title-preview">
        <h2 className="karma-title-preview">{title || 'Karma Matrisi Kalkulyatoru'}</h2>
        <p className="karma-subtitle-preview" style={{ whiteSpace: 'pre-line' }}>{subtitle || 'by Karma Akademi Canada'}</p>
      </div>
    </div>
  );
};

export default TitleEditor;
